import commonService from './common-service';

class EpcisService {
  async getEpcisFiles(pageNumber, pageSize, search, facilityIds = []) {
    try {
      const params = new URLSearchParams();
      params.append("pageNumber", pageNumber);
      params.append("pageSize", pageSize);
      if (search) params.append("search", search);
      if (facilityIds && facilityIds.length > 0) {
        facilityIds.forEach((id) => params.append("facilityIds", id));
      }
      const url = `Epcis/Files?${params.toString()}`;
      const response = await commonService.getFromServer(url, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error getting EPCIS files. Please contact administrator.');
      }
    } catch (e) {
      throw e;
    }
  }

  async getEpcisFileById(id) {
    try {
      const response = await commonService.getFromServer('Epcis/Files/' + id, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error getting EPCIS file. Please contact administrator.');
      }
    } catch (e) {
      throw e;
    }
  }

  async uploadEpcisFile(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await commonService.postToServer('Epcis/Upload', formData);
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading EPCIS file. Please contact administrator.');
      }
    } catch (e) {
      throw e;
    }
  }

  async getEpcisFileAudit(id) {
    try {
      const response = await commonService.getFromServer('Epcis/Files/' + id + '/Audit', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error getting audit data. Please contact administrator.');
      }
    } catch (e) {
      throw e;
    }
  }

  async reprocessEpcisFile(id) {
    try {
      const response = await commonService.postToServer('Epcis/Files/' + id + '/Reprocess', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error reprocessing file. Please contact administrator.');
      }
    } catch (e) {
      throw e;
    }
  }

  async deleteEpcisFile(id) {
    try {
      const response = await commonService.deleteToServer('Epcis/Files/' + id, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error deleting file. Please contact administrator.');
      }
    } catch (e) {
      throw e;
    }
  }
}

export default new EpcisService();
